module.exports = __webpack_public_path__ + "static/media/mid_huifu1.7de0bb95.png";